import './App.css';

import Footer from './Components/Footer/Footer';
import MainNavbar from './Components/Navbar/Navbar';
import { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import Router from './Routes/Router';

function App() {
  const [hide,setHide] = useState(false)
  return (
    <div className="App">
      <BrowserRouter>
        <MainNavbar/>
        <br/>
        <Router/>
        <Footer/>
      </BrowserRouter>
      
    </div>
  );
}

export default App;
